export default __webpack_public_path__ + "static/media/women-8.33fca418.jpg";